export const apiErrorCodes = {
    USER_EMAIL_TAKEN: 'USER_EMAIL_TAKEN',
    CHILD_GUARDIAN_ID_DUPLICATE: 'CHILD_GUARDIAN_ID_DUPLICATE',
    CHILD_LAST_PARENT_DELETE: 'CHILD_LAST_PARENT_DELETE',
    LESSON_ALREADY_HAS_TOPIC: 'LESSON_ALREADY_HAS_TOPIC',
    ARCHIVED_CHILD_UPDATE_FORBIDDEN: 'ARCHIVED_CHILD_UPDATE_FORBIDDEN',
    LESSON_MODIFICATION_FORBIDDEN: 'LESSON_MODIFICATION_FORBIDDEN',
    LESSON_ACCESS_FORBIDDEN: 'LESSON_ACCESS_FORBIDDEN',
    CHILD_PARENTS_WITHOUT_ACCOUNT: 'CHILD_PARENTS_WITHOUT_ACCOUNT',
    USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
    INSTITUTION_CHILD_LIMIT_EXCEEDED: 'INSTITUTION_CHILD_LIMIT_EXCEEDED',
    ABSENCE_DATES_NOT_CORRECT: 'ABSENCE_DATES_NOT_CORRECT',
    ABSENCES_ALREADY_EXIST: 'ABSENCES_ALREADY_EXIST',
    FORBIDDEN_TO_MODIFY_ABSENCE: 'FORBIDDEN_TO_MODIFY_ABSENCE',
    JOURNAL_NOT_FOUND: 'JOURNAL_NOT_FOUND',
    GROUP_NAME_TAKEN: 'GROUP_NAME_TAKEN',
    DELETE_ASSIGNED_ROLE: 'DELETE_ASSIGNED_ROLE',
    DIET_IN_USE_REMOVE_ATTEMPT: 'DIET_IN_USE_REMOVE_ATTEMPT',
    DIET_MEAL_TYPE_REMOVE_ATTEMPT: 'DIET_MEAL_TYPE_REMOVE_ATTEMPT',
    DIET_UPDATE_IN_PAST_ATTEMPT: 'DIET_UPDATE_IN_PAST_ATTEMPT',
    DIET_NAME_TAKEN: 'DIET_NAME_TAKEN',
    DIET_NOT_FOUND: 'DIET_NOT_FOUND',
    MEAL_TYPE_IN_USE_REMOVE_ATTEMPT: 'MEAL_TYPE_IN_USE_REMOVE_ATTEMPT',
    MENU_DATE_OVERLAPPING: 'MENU_DATE_OVERLAPPING',
    CHILD_HAS_ALREADY_REPLIED_TO_THREAD: 'CHILD_HAS_ALREADY_REPLIED_TO_THREAD',
    REPLY_MAIL_THREAD_NOT_FOUND: 'REPLY_MAIL_THREAD_NOT_FOUND',
    NOT_LATEST_MONTHLY_SETTLEMENT: 'NOT_LATEST_MONTHLY_SETTLEMENT',
    CHILD_PARENT_EMAIL_DUPLICATE: 'CHILD_PARENT_EMAIL_DUPLICATE',
    BILL_ALREADY_PAID: 'BILL_ALREADY_PAID',
    CHILD_GROUP_JOURNAL_DATES_OVERLAP: 'CHILD_GROUP_JOURNAL_DATES_OVERLAP',
    ATTENDANCE_NOT_AVAILABLE_FOR_ABSENT_TEACHER: 'ATTENDANCE_NOT_AVAILABLE_FOR_ABSENT_TEACHER',
    CHILD_NOT_SETTLED_ARCHIVE: 'CHILD_NOT_SETTLED_ARCHIVE',
    INSTITUTION_NON_WORKING_DAY: 'INSTITUTION_NON_WORKING_DAY',
    MODIFICATION_OF_LESSON_RANGE_WITHOUT_AFFECT_NEXT:
        'MODIFICATION_OF_LESSON_RANGE_WITHOUT_AFFECT_NEXT',
    LESSON_WITH_CHILD_OUTSIDE_OF_GROUP_RANGE: 'LESSON_WITH_CHILD_OUTSIDE_OF_GROUP_RANGE',
    FORBIDDEN_MODIFICATION_OF_PAST_LESSON_RANGE: 'FORBIDDEN_MODIFICATION_OF_PAST_LESSON_RANGE',
    NONE_LESSONS_CREATED: 'NONE_LESSONS_CREATED',
    GUS_COMPANY_NOT_FOUND: 'GUS_COMPANY_NOT_FOUND',
    RSPO_AND_REGON_MISMATCH: 'RSPO_AND_REGON_MISMATCH',
    NURSERY_NOT_FOUND: 'NURSERY_NOT_FOUND',
    PREVIOUS_MONTHLY_SETTLEMENT_NOT_VERIFIED: 'PREVIOUS_MONTHLY_SETTLEMENT_NOT_VERIFIED',
    FREE_FROM_WORK_CALENDAR_EVENT_LESSONS_CONFLICT:
        'FREE_FROM_WORK_CALENDAR_EVENT_LESSONS_CONFLICT',
    WORKING_DAY_LESSONS_CONFLICT: 'WORKING_DAY_LESSONS_CONFLICT',
    PAYU_CREDENTIALS_NOT_FOUND: 'PAYU_CREDENTIALS_NOT_FOUND',
    CHILD_BALANCE_NOT_NEGATIVE: 'CHILD_BALANCE_NOT_NEGATIVE',
    INVALID_PAYU_CREDENTIALS: 'INVALID_PAYU_CREDENTIALS',
    MEAL_TYPE_NAME_TAKEN: 'MEAL_TYPE_NAME_TAKEN',
    OVERLAPPING_DISCOUNT_EXIST: 'OVERLAPPING_DISCOUNT_EXIST',
    DATE_OUTSIDE_JOURNAL: 'DATE_OUTSIDE_JOURNAL',
    SETTLEMENT_IS_VERIFIED: 'SETTLEMENT_IS_VERIFIED',
    COST_SPLIT_AMOUNT_TOO_LARGE: 'COST_SPLIT_AMOUNT_TOO_LARGE',
    CHILD_JOURNAL_DATES_OUTSIDE_JOURNAL_DATES: 'CHILD_JOURNAL_DATES_OUTSIDE_JOURNAL_DATES',
};
